import { DetailedKeyword, Paging } from "./ProjectKeywordsResponse";
import { ContactRequest } from "./ContactRequest";

export interface CreateActionItemRequest {
    projectNrn: string;
    subject: string;
    dueDate?: string;
    complete?: number; // 0-100
    description?: string;
    type?: DetailedKeyword;
    assignedBy?: ContactRequest;
    assignedTo?: ContactRequest[];
}

export interface CreateActionItemResponse {
    nrn: string;
}

export interface AttachmentLinkResponse {
    path: string;
    status: number;
    body?: any;
}

export enum AttachmentLinkRequestOpType {
    add = "add",
    remove = "remove",
}

export interface AttachmentLinkRequest {
    op: AttachmentLinkRequestOpType;
    path: string;
}

export interface ActionItemType {
    name: string;
    type: string;
}

export interface ActionItems {
    projectNrn: string;
    subject: string;
    assignedBy: string | null;
    assignedTo: string[];
    dueDate: string | null;
    complete: number;
    description: string;
    type: ActionItemType;
    nrn: string;
    createdDate: string;
    statusType: string;
    statusLabel: string;
    supportingDocumentCount: number;
    discussionItemCount: number;
    projectName: string;
    number: string;
}

export interface ActionItemsResponse {
    items: ActionItems[];
    paging?: Paging;
}

export interface ActionItemsRequest {
    to?: string;
    by?: string;
    showAll?: boolean;
}
